import React from 'react';
import Look from './Look';
import About from './About/';
import AddAward from './AddAward';
import AddCertification from './AddCertification';
import Experience from './Experience';
import PremiumMainHolder from './PremiumMainHolder';
import AddHolder from './AddHolder';
import Addlawyer from './Add';
import Contact from './Contact';
import SocialNetworks from './SocialNetworks';
import Site from './Site';
import Cost from './Cost';
import AddPublication from './AddPublication';
import AddLaboral from './AddLaboral';
import AddSpecialty from './AddSpecialty';
import ResponseTime from './ResponseTime';
import Picture from './Picture';
import VideoProf from './VideoProf';
import Share from './Share';
import Progress from './Progress';
import Community from "./Community";
import Schedule from './Schedule';
import Education from './Education';
import Courses from './Courses';
import { connect } from 'react-redux';
import ModalFree from "../../components/Modal/ModalFree";
import BannerPremium from './BannerPremium';

function ProfileSections({ role, community, membership, authClient, idLawFirm }) {
  return (
    <>
      <ModalFree />
      <div className="bodyProfile">
        <div id="cardContainer">
          <div>
            <Look name="look" />
          </div>

          {idLawFirm ? (
            <div>
              <PremiumMainHolder name="premiumMainHolder" />
            </div>
          ) : null}

          {authClient &&
          authClient.membership &&
          authClient.membership.type === "Freemium" ?
            <div>
              <BannerPremium name="bannerPremium" />
            </div> : null
          }

          <div>
            <About name="about" />
          </div>

          <div>
            <AddSpecialty name="specialty" />
          </div>

          <div>
            <Experience name="expertise" role={role} />
          </div>

          {role === 'lawyer' ? (
              <>
                <div><Education name="education-lawyer" /></div>
                <div><Courses name="courses" /></div>
                <div><AddCertification name="certification" /></div>
                <div><AddAward name="award" /></div>
                <div><AddPublication name="publication" /></div>
                <div><AddLaboral name="laboral" /></div>
              </>
            ) : null
          }
          
          <div>
            <Contact name="contact" role={role} />
          </div>

          {authClient &&
          authClient.membership &&
          authClient.membership.type === "Freemium" &&
          authClient.role === 'lawyer' ?
            <div>
              <BannerPremium name="bannerPremium" />
            </div> : null
          }
              
          <div>
            <SocialNetworks name="socialNetworks" role={role} />
          </div>

          {role === 'lawFirm' ? (
            <>
              <div>
                <AddHolder name="addHolder" />
              </div>
              <div>
                <Addlawyer name="add" />
              </div>
            </>
          ) : null}


          {authClient &&
          authClient.membership &&
          authClient.membership.type === "Freemium" &&
          authClient.role === 'lawFirm' ?
            <div>
              <BannerPremium name="bannerPremium" />
            </div> : null
          }

          <div>
            <Site name="site" role={role} />
          </div>

          <div>
            <Schedule name="schedule" />
          </div>

          <div>
            <Cost name="cost" />
          </div>
            
          <div>
            <Community name="communitySection" role={role} />
          </div>

          {community ?
            <div>
              <ResponseTime name="responseTime" />
            </div> :
            null
          }

          <div>
            <Picture name="picture" trash={true} />
          </div>

          <div>
            <VideoProf name="videos" />
          </div>

          <div>
            <Share name="share" />
          </div>

          {authClient &&
          authClient.membership &&
          authClient.membership.type === "Freemium" ?
            <div>
              <BannerPremium name="bannerPremium" />
            </div> : null
          }

          <div>
            <Progress />
          </div>

          <p className='profile-terms'>
            La información solicitada es para llenar
            los campos que serán mostrados en su perfil
            público, el cual está sujeto a nuestros Términos y
            Condiciones y a la Política de Privacidad de Contacta Abogado®.
          </p>
        </div>
      </div>
    </>
  );
}

const mapStateToProps = state => ({
  role: state.authClient.role,
  idLawFirm: state.authClient.idLawFirm,
  community: state.authClient.community,
  authClient: state.authClient,
  membership: state.authClient.membership,
});

export default connect(mapStateToProps)(ProfileSections);
